export default {
    clientLoading: false,
    clientsListLoading: false,
    clientsList: [],
    pdrListLoading: false,
    pdrLists: [],
    priceLists: {}
}